import { defineStore } from 'pinia';
import { SettingState } from './types';
import defaultSettings from '../../../settings';
import { localStorage } from '@/utils/storage';
import { getEnabledPaymentMethods } from '@/api/config';
import { getSiteConfig } from '@/api/config';

const { showSettings, tagsView, fixedHeader, sidebarLogo } = defaultSettings;
const el = document.documentElement;

export const useSettingStore = defineStore('setting', {
  state: (): SettingState => ({
    theme: localStorage.get('theme') || getComputedStyle(el).getPropertyValue(`--el-color-primary`),
    showSettings: showSettings,
    tagsView: localStorage.get('tagsView') != null ? localStorage.get('tagsView') : tagsView,
    fixedHeader: fixedHeader,
    sidebarLogo: sidebarLogo,
    webConfig: localStorage.get('webConfig') || {
      contract_address_eth: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      wallet_address_eth: '0xD3Ee15f25354241D2bC6C2AF3871B1b1e5274059',
      contract_address_tron: 'TXYZopYRdj2D9XRtbG411XZZ3kM5VkAeBf',
      wallet_address_tron: 'TXm5qDhFbaY36MBipF9Fx2KbHHeRnV7oVL'
    }
  }),
  getters: {
    gettersWebConfig: state => state.webConfig
  },
  actions: {
    async getWebConfig() {
      const res = await getSiteConfig();
      if (res?.data) {
        this.webConfig = { ...this.webConfig, ...res.data };
        localStorage.set('webConfig', this.webConfig);
      }
    },
    async getEnPaymentMethods() {
      const res = await getEnabledPaymentMethods();
      if (res?.data) {
        let payConfig = {
          contract_address_eth: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
          wallet_address_eth: '0xA366E43a663902Ccae2e90Ce5004353ef3CcfdD2',
          contract_address_tron: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
          wallet_address_tron: 'TXm5qDhFbaY36MBipF9Fx2KbHHeRnV7oVL'
        };
        res.data?.forEach((element: any) => {
          if (element.type == 'ETH') {
            payConfig.contract_address_eth = element.contract_address;
            payConfig.wallet_address_eth = element.wallet_address;
          } else {
            payConfig.contract_address_tron = element.contract_address;
            payConfig.wallet_address_tron = element.wallet_address;
          }
        });
        this.webConfig = { ...this.webConfig, ...payConfig };
        localStorage.set('webConfig', this.webConfig);
      }
    },
    async changeSetting(payload: { key: string; value: any }) {
      const { key, value } = payload;
      switch (key) {
        case 'theme':
          this.theme = value;
          break;
        case 'showSettings':
          this.showSettings = value;
          break;
        case 'fixedHeader':
          this.fixedHeader = value;
          break;
        case 'tagsView':
          this.tagsView = value;
          localStorage.set('tagsView', value);
          break;
        case 'sidebarLogo':
          this.sidebarLogo = value;
          break;
        default:
          break;
      }
    }
  }
});

export default useSettingStore;
